export const splitArray = <T = unknown>(array: T[], chunkSize: number): T[][] =>
    array.reduce((chunks, item, i) => {
        if (i % chunkSize === 0) {
            chunks.push([item]);
        } else {
            chunks[chunks.length - 1].push(item);
        }
        return chunks;
    }, [] as T[][]);

export const startsWithAny =
    (startsWithValues: string[]) =>
    (valueToCheckAgainst: string, idx = 0): null | string => {
        if (valueToCheckAgainst.startsWith(startsWithValues[idx])) {
            return startsWithValues[idx];
        }
        if (idx === startsWithValues.length - 1) return null;
        return startsWithAny(startsWithValues)(valueToCheckAgainst, idx + 1);
    };

export const isArrayWithValues = <T = unknown>(arr?: unknown): arr is T[] =>
    Boolean(arr && Array.isArray(arr) && arr.length);

export const removeNullValues = <T = unknown>(arr: T[]): T[] => arr.filter((x) => x !== null);

export const createArrayElementChecker =
    <T>(xs: T[]) =>
    (ys: T[]) =>
        xs.some((x) => ys.includes(x));

export const randomArrayValue = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

export const newArrayWithElementToEndAtIndex = <T>(
    arr: T[] | null = null,
    index: number | null = null,
): T[] => {
    if (!arr || index === null || index < 0 || index >= arr.length) {
        return arr ? [...arr] : [];
    }

    const newArr = [...arr];
    const el = newArr.splice(index, 1)[0];
    newArr.push(el);
    return newArr;
};
